import React, { useState, useEffect } from 'react';
import '../assets/styles/Login.css'; // reutiliza estilos de login
import { useNavigate, useSearchParams } from 'react-router-dom';

// Tela para solicitar link de recuperação de senha
export default function RecuperarSenha() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [step, setStep] = useState('email');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  // Ao montar, verifica se há email na query para reset direto
  useEffect(() => {
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
      setStep('reset');
    }
  }, [searchParams]);

  // Envia instrução para o usuário procurar o admin
  const handleEnviarLink = async (e) => {
    e.preventDefault();
    if (!email) {
      setMensagem('Informe seu email para recuperar a senha.');
      return;
    }
    setMensagem('Entre em contato com o administrador para redefinir sua senha.');
  };

  // Redefine a senha usando apenas email e nova senha (NÃO recomendado para produção)
  const handleRedefinirSenha = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMensagem('As senhas não coincidem.');
      return;
    }
    if (!email) {
      setMensagem('Email não informado.');
      return;
    }
    try {
      // Buscar usuário pelo email
      const resBusca = await fetch(`/api/usuarios/`);
      const lista = await resBusca.json();
      const usuario = Array.isArray(lista) ? lista.find(u => u.email === email) : null;
      if (!usuario) {
        setMensagem('Usuário não encontrado para este email.');
        return;
      }
      // Atualizar senha
      const res = await fetch('/api/usuarios/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: usuario.id,
          nome: usuario.nome,
          email: usuario.email,
          senha_hash: newPassword,
          perfil: usuario.perfil,
          data_cadastro: usuario.data_cadastro,
          ativo: usuario.ativo
        })
      });
      if (!res.ok) throw new Error('Erro ao redefinir senha');
      setMensagem('Senha alterada com sucesso! Redirecionando...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMensagem('Erro ao redefinir senha: ' + err.message);
    }
  };

  return (
    <div className='body-login'>
      <form className='Box-Login' onSubmit={step === 'email' ? handleEnviarLink : handleRedefinirSenha}>
        <h1>{step === 'email' ? 'RECUPERAR SENHA' : 'NOVA SENHA'}</h1>
        {step === 'email' ? (
          <>
            <p>Digite seu email cadastrado</p>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Email de recuperação"
              required
            />
            <button type="submit" className='login-button'>Solicitar Redefinição</button>
          </>
        ) : (
          <>
            <p>Digite sua nova senha</p>
            <input
              type="password"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Nova senha"
              required
            />
            <p>Confirme a nova senha</p>
            <input
              type="password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Confirme a senha"
              required
            />
            <button type="submit" className='login-button'>Redefinir Senha</button>
          </>
        )}
        <button type="button" className='resetButton' onClick={() => navigate('/login')}>Voltar ao Login</button>
        {mensagem && (
          <p style={{ color: mensagem.startsWith('Erro') ? 'red' : 'green' }}>
            {mensagem}
          </p>
        )}
      </form>
    </div>
  );
}
